import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';

const DashboardLayout = ({ isSidebarOpen, toggleSidebar, children }) => {
  const authToken = localStorage.getItem('authToken');
  return (
    <div className='dashboard-layout'>
      <Navbar toggleSidebar={toggleSidebar} />
      <div className='dashboard-content'>
        <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <main className='main-content'>
          {authToken ? <Outlet /> : <Navigate to='/' replace />}
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
